import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const included = ['Ready-to-teach class ideas', 'Time-saving planning support', 'Choreography inspiration', 'Cardio-based class structures', 'Themed class concepts', 'Annual planning tools', 'Instructor confidence and growth', '5 premium bonuses', 'Instant access and 7-day guarantee'];
export function FinalCTA() {
  return <section className="bg-navy px-4 py-20 text-white sm:py-24" data-id="element-88">
      <div className="mx-auto max-w-4xl" data-id="element-89">
        <header className="text-center" data-id="element-90">
          <p className="headline-kicker text-xs font-bold text-violet-light" data-id="element-91">
            READY WHEN YOU ARE
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase leading-tight sm:text-5xl" data-id="element-92">
            Next Monday, keep building from scratch...{' '}
            <span className="text-violet-light" data-id="element-93">or teach with confidence.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-slate-200" data-id="element-94">
            Dance Fitness Instructor Pro™ gives you the time, tools, and
            complete system to show your best in every class.
          </p>
        </header>
        <article className="mt-12 rounded-3xl border border-white/20 bg-white p-7 text-navy shadow-xl sm:p-10" data-id="element-95">
          <h3 className="text-center font-display text-2xl font-black uppercase" data-id="element-96">
            Your complete system includes
          </h3>
          <div className="mt-7 grid gap-x-8 gap-y-3 md:grid-cols-2" data-id="element-97">
            {included.map(item => <p key={item} className="flex items-center gap-2 text-sm text-slate-700" data-id="element-98">
                <CheckIcon size={16} className="shrink-0 text-violet" data-id="element-99" />
                {item}
              </p>)}
          </div>
          <div className="mt-9 text-center" data-id="element-100">
            <p className="rounded-xl bg-violet-mist p-5 text-base italic text-navy" data-id="element-101">
              “The best time to have this system was before your very first
              class.{' '}
              <strong className="not-italic text-violet" data-id="element-102">
                The second best time is today.
              </strong>
              ”
            </p>
            <p className="mt-7 font-display text-xl font-black uppercase" data-id="element-103">
              Dance Fitness Instructor Pro™
            </p>
            <p className="mt-2 text-sm text-slate-600" data-id="element-104">
              120 complete ready-to-teach classes to help instructors plan less
              and teach with confidence.
            </p>
            <CheckoutButton className="mt-7 w-full sm:w-auto" data-id="element-105">
              START TEACHING WITH CONFIDENCE
            </CheckoutButton>
            <p className="mt-4 text-xs text-slate-500" data-id="element-106">
              Instant digital access • Secure checkout • 7-day guarantee
            </p>
          </div>
        </article>
      </div>
    </section>;
}